import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../../styled'
import { formSectionTitleCss } from '../../../legacy-design-system/text'

export function Body({
  children,
  className
}: {
  readonly children: React.ReactNode
  readonly className?: string
}) {
  return (
    <div
      className={cx(
        css`
          label: wizard-body;
          padding-top: ${rowSpace};
          padding-bottom: ${rowSpace};
          max-width: 1024px;
          &::-webkit-scrollbar {
            background: transparent;
          }
          [class^='col'] {
            padding-left: 0;
          }
        `,
        className
      )}
    >
      {children}
    </div>
  )
}

export const subtitleCss = cx(
  formSectionTitleCss,
  css`
    margin-bottom: 10px;
  `
)

export const clickableCss = css`
  cursor: pointer;
`

export const smallIconCss = css`
  padding-right: 7px;
`

export const iconSize = 14

export const placeholderCss = css(`
  padding: ${deprecatedTheme.padding.comboboxInput};
  color: ${theme.color.neutral40};
  font-family: ${deprecatedTheme.fontFamilies.secondary};
  font-size: 14px;`)

export const radioList = css(`
  margin-bottom: 25px;
  list-style-type: none;
  padding: 0;`)

export const rowSpace = '25px'
